/**
 * 商品service
 */

import {
	POST,
	GET
} from './service.config.js'


/**
 * 获取商品详情信息
 * @param goodsId 商品ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getGoodsDetailsInfoService = goodsId => POST('btrgoods/getGoodsInfo', {
	goods_id: goodsId
});


/**
 * 获取商品规格
 * @param goodsId 商品ID
 * @returns {*|Promise<unknown>}
 */
export const getGoodsSpecsService = goodsId => POST('btrgoods/goodSpec', {
	goods_id: goodsId
});

/**
 * 获取商品规格
 * @param goodsId 商品ID
 * @returns {*|Promise<unknown>}
 */
export const getCateShopGoods = (cid,lat,lng,page) => POST('newapi/getCateShopGoods', {
	cid,
	lat,
	lng,
	page
});



















/**
 * 获取商品列表
 * @param shopId 商品ID
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getGoodsListService = (shopId, page, limit) => POST('btrexchange/shop_goods', {
	shop_id: shopId,
	page,
	limit,
});


/**
 * 获取商品详情
 * @param shopId 商家ID
 * @param goodsId 商品ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getGoodsDetailsService = (shopId, goodsId) => POST('btrexchange/goodsInfo', {
	shop_id: shopId,
	goods_id: goodsId,
});


/**
 * 获取首页轮播图和图标信息
 * @param show_type 显示位置:0通用，1公众号，2App
 * @param show_position 显示位置0轮播图，1图标
 * @returns {*|Promise|Promise<unknown>}
 */
export const getBannersListService = (show_type, show_position) => POST('btrbasic/bannerslist', {
	show_type,
	show_position,
});


/**
 * 获取一级分类
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOneCategoryService = () => GET('btrbasic/getOneTypeList');

/**
 * 获取二级分类
 * @param id 一级分类ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getTwoThreeTypeListService = id => POST('btrbasic/getTwoThreeTypeList', {
	id
});


/**
 * 获取首页新品商品信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const getNewGoodsService = () => GET('btrgoods/newProducts');

/**
 * 获取首页推荐商品信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const getRecommendGoodsService = (page, limit) => POST('btrgoods/recommend', {
	page,
	limit,
});

/**
 * 获取商品详情信息
 * @param goodsId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getGoodsInfoService = goodsId => POST('btrgoods/getGoodsInfo', {
	goods_id: goodsId
});


/**
 * 获取商品尺寸
 * @param goodsId 商品编号
 * @returns {*|Promise<unknown>}
 */
export const getGoodsSizeService = (goodsId) => POST('btrgoods/goodSpec', {
	goods_id: goodsId
});

/**
 *
 * @param typeId 商品类别 0 所有
 * @param page
 * @param limit
 * @param order 搜索类别，0综合排序，1销量，2价格
 * @param status 排列方式 0 正序,1反序
 * @param name 搜索关键字
 * @returns {*|Promise|Promise<unknown>}
 */
export const getGoodsMusterService = (typeId, page, limit, order, status, name) => POST('btrgoods/goodsList', {
	tid: typeId,
	page,
	limit,
	order_sort: order,
	status,
	name,
});

/**
 * 获取热门搜索商品信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const getHotGoodsService = (page, limit) => POST('btrbasic/popularSearch', {
	page,
	limit,
});


/**
 * 获取首页信息
 * @param type 标识1：公众号
 * @returns {*|Promise|Promise<unknown>}
 */
export const getHomeService = type => POST('btrgoods/homePage', {
	show_type: type,
});

/**
 * 获取特价商品
 */
export const getGoodsOfferService = (page, limit, searchkey, typeId) => POST('btrgoods/getGoodsOffer', {
	page,
	limit,
	name: searchkey,
	typeId
});

/**
 * 获取品牌信息
 */
export const getBrandsService = (page) => POST('btrgoods/getBrands',{
	page
});

/**
 * 商家特色服务一级分类
 */
export const getShopGoodsCate1 = () => POST('newapi/getShopGoodsCate1');

/**
 * 商家特色服务二级分类
 */
export const getShopGoodsCate2 = (pid) => POST('newapi/getShopGoodsCate2',{
	pid
});

/**
 * 商家特色服务订单
 */
export const getShopGoodsOrder = (uid,page) => POST('newapi/getShopGoodsOrder',{
	uid,
	page
});

/**
 * 保存商家服务订单
 */
export const saveShopGoodsOrder = (id) => POST('newapi/saveShopGoodsOrder',{
	id,
});

/**
 * 商家特色服务订单
 */
export const getNewShopGoodsOrder = (uid,page) => POST('newapi/getNewShopGoodsOrder',{
	uid,
	page
});

/**
 * 保存商家服务订单
 */
export const saveNewShopGoodsOrder = (id) => POST('newapi/saveNewShopGoodsOrder',{
	id,
});

/**
 * 代理商商品列表
 * @param typeId 商品类别 0 所有
 * @param page
 * @param limit
 * @param order 搜索类别，0综合排序，1销量，2价格
 * @param status 排列方式 0 正序,1反序
 * @param name 搜索关键字
 * @returns {*|Promise|Promise<unknown>}
 */
export const getDlGoodsService = (typeId, page, limit, order, status, name) => POST('dl/goodsList', {
	tid: typeId,
	page,
	limit,
	order_sort: order,
	status,
	name,
});

/**
 * 限时抢购商品列表
 * @param typeId 商品类别 0 所有
 * @param page
 * @param limit
 * @param order 搜索类别，0综合排序，1销量，2价格
 * @param status 排列方式 0 正序,1反序
 * @param name 搜索关键字
 * @returns {*|Promise|Promise<unknown>}
 */
export const getXsGoodsService = (typeId, page, limit, order, status, name) => POST('btrgoods/xianshiGoodsList', {
	tid: typeId,
	page,
	limit,
	order_sort: order,
	status,
	name,
});
